import { lazy } from 'react';

import { routes } from '@/constants/Constants';

const ZgriDashboardRoute = lazy(() =>
  import('./routes/zgri-dashboard.route').then((module) => ({
    default: module.ZgriDashboardRoute,
  })),
);

export const zgriRoutes = [
  {
    path: routes.rentersInsurance,
    component: ZgriDashboardRoute,
    title: 'Renters Insurance | TheGuarantors',
  },
];
